import InventoriesSelect from "./InventoriesSelect";

export default InventoriesSelect;
